import { revisionPartVOs } from "./revision-part-vo.model";

export interface RevisionModel {
  costLabor: number;
  createDate: Date;
  createUser: string;
  fixedPrice?: string;
  modelEndDate: string;
  modelStartDate: string;
  monthService: number;
  motorDescription: string;
  price: number;
  revisionPartVOs: revisionPartVOs[];
  service: string;
  serviceDescription: string;
  serviceId: number;
  tma: string;
  totalPriceItems: string
  totalTimeLaborItems: number
  duration?: number;
}
